import { render } from "./PolicyDocument1.vue?vue&type=template&id=05fddf38&scoped=true"
import script from "./PolicyDocument1.vue?vue&type=script&lang=js"
export * from "./PolicyDocument1.vue?vue&type=script&lang=js"

import "./PolicyDocument1.vue?vue&type=style&index=0&id=05fddf38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fddf38"]])

export default __exports__